import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useAuthProvider } from '../../utils/auth';
import { config } from '../../config/environment';

const BANNER_DISMISSED_KEY = 'betaModeBannerDismissed';

const ContentWrapper = ({ children, sx = {} }) => {
  const { isAuthed, userType } = useAuthProvider();
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  
  // Add bottom padding when music player is visible (for listeners)
  const bottomPadding = isAuthed && userType === 'listener' ? 16 : 0;
  
  // Check if beta banner is visible in staging
  useEffect(() => {
    if (config.isStaging) {
      const checkBannerVisibility = () => {
        // Use sessionStorage so it resets each session
        const dismissed = sessionStorage.getItem(BANNER_DISMISSED_KEY) === 'true';
        setIsBannerVisible(!dismissed);
      };
      
      checkBannerVisibility();
      
      // Listen for storage changes (when banner is dismissed in same tab)
      const handleStorageChange = (e) => {
        if (e.key === BANNER_DISMISSED_KEY) {
          checkBannerVisibility();
        }
      };
      window.addEventListener('storage', handleStorageChange);
      
      // Also check periodically in case dismissed in same window
      const interval = setInterval(checkBannerVisibility, 100);
      
      return () => {
        window.removeEventListener('storage', handleStorageChange);
        clearInterval(interval);
      };
    }
  }, []);
  
  // Add top padding when beta banner is visible in staging
  // Banner height is approximately 48px (Material-UI Alert default)
  const topPadding = isBannerVisible ? 6 : 0; // 48px banner = ~6 spacing units
  
  return (
    <Box
      sx={{
        pt: topPadding,
        pb: bottomPadding,
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export default ContentWrapper;
